module.exports = __webpack_public_path__ + "static/media/mahameru2.54ea1f60.jpg";